import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';
import {IAuthUser} from '../model/token-user.model';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'app-capture-app',
  templateUrl: './capture-app.component.html',
  styleUrls: ['./capture-app.component.scss']
})
export class CaptureAppComponent implements OnInit {

  public authUser: IAuthUser;

  isDarkMode = false;

  constructor(private router: Router, private authenticationService: AuthenticationService, private themeService: ThemeService) {
  }

  logout() {
    this.authenticationService.logout();
  }


  ngOnInit(): void {
    this.authUser = this.authenticationService.getUserAuthData();
    this.themeService.darkMode$.subscribe(isDark => {
      this.isDarkMode = isDark;
    });
  }

  public navigateToListTasks(): void {
    this.router.navigate(['/capture']).then();
  }

  toggleTheme() {
    this.themeService.toggleDarkMode();
  }
}
